<template>
  <VModal disable-backdrop-click @close="$emit('close')">
    <template #default="modalProps">
      <div class="mx-auto bg-white rounded-lg text-left shadow-xl lg:max-w-5xl sm:w-full">
        <div class="flex flex-col divide-y">
          <div class="flex-none p-4">
            <div class="flex justify-between items-center">
              <div class="flex-1">Select Media</div>
              <div class="flex-none flex space-x-3">
                <BaseButton ghost type="button" @click="modalProps.close"> Close </BaseButton>
                <BaseButton
                  primary
                  type="button"
                  :disabled="!hasSelectedMedia"
                  @click="selectMedia().then(modalProps.close)"
                >
                  Select
                </BaseButton>
              </div>
            </div>
          </div>
          <BaseFetchData :action="fetchData">
            <template #default>
              <div class="flex-1 p-4">
                <ul v-if="media.length" class="grid grid-cols-6 gap-4 p-4">
                  <li
                    v-for="mediaItem in media"
                    :key="mediaItem.id"
                    class="aspect-w-1 aspect-h-1 overflow-hidden group relative"
                  >
                    <img :src="mediaItem.url" class="w-full h-full object-cover rounded-lg" />
                    <div
                      v-if="selectedMediaIds.includes(mediaItem.id)"
                      class="w-full h-full top-0 left-0 absolute bg-blue-600 bg-opacity-75 rounded-lg flex items-center justify-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-10 w-10 text-white"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="
                            M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0
                            00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414
                            1.414l2 2a1 1 0 001.414 0l4-4z
                          "
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                    <label class="absolute top-0 left-0 w-full h-full rounded-lg">
                      <input
                        :type="multiple ? 'checkbox' : 'radio'"
                        class="hidden"
                        v-model="selectedMedia"
                        :value="mediaItem"
                      />
                    </label>
                  </li>
                </ul>
              </div>
            </template>
          </BaseFetchData>
        </div>
      </div>
    </template>
  </VModal>
</template>

<script>
import { mediaLibraryMediaClient } from '@/api/clients';

export default {
  name: 'MediaSelectDialog',
  props: {
    multiple: Boolean,
    mimeTypes: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      response: null,
      selectedMedia: null,
    };
  },
  computed: {
    media() {
      return this.response?.data || [];
    },
    selectedMediaIds() {
      if (!this.selectedMedia) {
        return [];
      }

      return (Array.isArray(this.selectedMedia) ? this.selectedMedia : [this.selectedMedia]).map(
        (selectedMediaItem) => selectedMediaItem.id
      );
    },
    hasSelectedMedia() {
      return this.selectedMediaIds.length > 0;
    },
  },
  methods: {
    fetchData() {
      return mediaLibraryMediaClient
        .list({
          filter: {
            mime_type_like: this.mimeTypes,
          },
        })
        .then((response) => {
          this.response = response;
        });
    },
    selectMedia() {
      return new Promise((resolve, reject) => {
        if (!this.hasSelectedMedia) {
          reject();
          return;
        }

        this.$emit('select', this.selectedMedia);

        resolve();
      });
    },
  },
};
</script>
